var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useFormLayoutContext } from '../form-layout';
import { styled } from '../../styled';
import clsx from '../../utils/clsx';
import { formActionsClasses, formActionsComponentName, getFormActionsUtilityClass, } from './form-actions-classes';
import { useMergedClasses } from '../../styles/classes';
var Root = styled('div', { name: formActionsComponentName, slot: 'Root' })(function (_a) {
    var _b, _c;
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign({ display: 'grid', gridTemplateColumns: '1fr' }, (ownerState.layout === 'two-column' && (_b = {},
        _b[theme.breakpoints.up('md')] = (_c = {
                gridGap: theme.spacing(5),
                gridTemplateColumns: '2fr 3fr'
            },
            _c["& .".concat(formActionsClasses.actions)] = {
                gridColumnStart: 2,
            },
            _c),
        _b)));
});
var Actions = styled('div', { name: formActionsComponentName, slot: 'Actions' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign({ display: 'flex', alignItems: 'center' }, (!ownerState.disableSpacing && {
        gap: theme.spacing(2),
    }));
});
export var FormActions = React.forwardRef(function (props, ref) {
    var layoutProp = props.layout, _a = props.disableSpacing, disableSpacing = _a === void 0 ? false : _a, children = props.children, className = props.className, rootProps = __rest(props, ["layout", "disableSpacing", "children", "className"]);
    var layoutContext = useFormLayoutContext().layout;
    var classes = useMergedClasses(formActionsClasses, getFormActionsUtilityClass, props.classes);
    var layout = layoutProp || layoutContext;
    var ownerState = {
        layout: layout,
        disableSpacing: disableSpacing,
    };
    return (React.createElement(Root, __assign({ ref: ref, ownerState: ownerState }, rootProps, { className: clsx(classes.root, className) }),
        React.createElement(Actions, { ownerState: ownerState, className: classes.actions }, children)));
});
